export default __webpack_public_path__ + "static/media/Group16.8b06d30a.png";